// Porta única dos BOTÕES que levam ao Premium ("Ver planos", "Evoluir meu
// plano", cadeado do blur, "Conhecer o Premium", link /app/premium...).
//
// No app NATIVO todos abrem o funil novo começando pelo Comparativo:
//   comparativo → lembrete do teste (só com teste elegível e
//   LEMBRETE_TESTE_ATIVO) → planos da loja.
// O pós-intersticial não passa por aqui: ele continua começando na Oferta
// (monetizacao.depoisDaAcao).
//
// Na WEB nada muda: quem chama recebe `false` e segue no caminho antigo
// (offcanvas Premium / ModalPlans com o Sliders → /assinar).

import { Capacitor } from '@capacitor/core';

// O serviço de monetização entra sob demanda: este módulo é importado por
// peças leves (PaywallContext, ModalPlans) e não precisa arrastar Firestore e
// AdMob para o grafo de quem só quer um botão. No app ele já está carregado
// (MonetizacaoHost), então o import resolve na hora.
function abrirFunilPremium(opts) {
  return import('../monetizacao/monetizacao').then((m) => m.abrirFunilPremium(opts));
}

export const INICIO_BOTAO = 'comparativo';

/**
 * Transforma o que o chamador passou numa `origem` curta. Aceita a string
 * pronta, o contexto do PaywallContext ({origem, feature}) ou nada — e ignora
 * o evento de clique de quem liga `onClick={onShowPremium}` direto.
 * @param {*} ctx
 * @param {string} [padrao]
 * @return {string}
 */
export function origemDe(ctx, padrao = 'botao') {
  if (typeof ctx === 'string' && ctx.trim()) return ctx.trim();
  if (ctx && typeof ctx === 'object' && !ctx.nativeEvent && !ctx.target) {
    const partes = [ctx.origem, ctx.feature].filter((v) => typeof v === 'string' && v);
    if (partes.length) return partes.join(':');
  }
  return padrao;
}

/** O funil novo substitui as telas antigas de Premium nesta plataforma? */
export function funilNoLugarDoPremium() {
  return Capacitor.isNativePlatform();
}

/**
 * Abre o funil do Premium a partir de um botão. Devolve `true` quando abriu
 * (nativo) e `false` na web — aí quem chamou segue no fluxo antigo.
 * @param {*} ctx origem (string) ou contexto do paywall
 * @param {string} [padrao] origem quando `ctx` não diz nada
 * @return {boolean}
 */
export function abrirPremiumPorBotao(ctx, padrao) {
  if (!funilNoLugarDoPremium()) return false;
  abrirFunilPremium({ origem: origemDe(ctx, padrao), inicio: INICIO_BOTAO }).catch(() => {});
  return true;
}
